import { CalculationKeynameEnum } from '../../enums/calculations/calculation-keyname.enum';
import { FileFillerInterface } from '../../interfaces/file-filler.interface';
import { CalculationResponse } from '../../responses/calculation.response';
import { Section84_1PdfFiller } from '../pdf-fillers/section-84_1.pdf-filler';

export class PdfFillerFactory {
  constructor(
    private readonly section841PdfFiller: Section84_1PdfFiller,
  ) {
  }

  getPdfFiller(calculation: CalculationResponse): FileFillerInterface {
    switch (calculation.calculationKeyname) {
      case CalculationKeynameEnum.Section84_1: {
        return this.section841PdfFiller;
      }
      // case CalculationKeynameEnum.Roulement:
      //     // return new Roulement(options);
      //     break;
      default:
        throw new Error(`Calculation ${calculation.calculationKeyname} is not supported`);
    }
  }
}
